<!-- 个性化配置 -->
<template>
    <div class="ml20">
        <el-form ref="form" :model="formItem" label-width="150px" v-loading="dataLoading" class="form-box">  
            <template v-for="item in allSettingConfig">
                <div v-if="item.type == 'title'&&item.children" class="group-item mb20 mr20" :key="item.name">
                    <el-form-item label-width="0">
                        <div class="title-group text-bold ml20 mt10">{{ item.label }}：</div>
                    </el-form-item>
                    <el-form-item :label="inner.label" :prop="inner.name" :key="inner.name" v-for="inner in item.children">
                        <el-select v-model="formItem[inner.name]" placeholder="请选择" clearable filterable v-if="inner.type == 'select'">
                            <el-option v-for="option in inner.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
                        </el-select>
                        <el-radio-group v-model="formItem[inner.name]"  v-if="inner.type == 'radio'">
                            <el-radio v-for="option in inner.options" :key="option.value"  :label="option.value" @dblclick.native="testRadio(option)">{{ option.label }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <template v-else>
                    <el-form-item :label="item.label" :prop="item.name" :key="item.name">
                        <el-select v-model="formItem[item.name]" placeholder="请选择" clearable filterable v-if="item.type == 'select'">
                            <el-option v-for="option in item.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
                        </el-select>
                        <el-radio-group v-model="formItem[item.name]"  v-if="item.type == 'radio'">
                            <el-radio v-for="option in item.options" :key="option.value"  :label="option.value" @dblclick.native="dblClickRadio(item)">{{ option.label }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </template>
            </template> 
        </el-form>
        <div class="dialog-footer tac mt20">
            <el-button type="default" @click="closeModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="confirmModal" :loading="submitLoading" class="action-btn ml20">提交</el-button>
        </div>
    </div>
</template>

<script>
    import API from '@/api/home';
    import store from '@/store';

    export default {
        name: "PageConfigModal",
        props:{
            cbs:Object,
            props:Object,
        },
        data(){
            return {
                formItem:{
                    // default_page:'',
                },
                allSettingConfig:[],
                submitLoading:false,
                dataLoading:true,
            }
        },
        computed:{
        },
        mounted(){
            this.getCommonConfig();
        },
        methods:{
            confirmModal(){
                console.log(this.formItem);
                // this.cbs.onConfirm({});
                this.submitLoading = true;
                let params = {...this.formItem};
                API.setUserPageConfig(params).then(res=>{
                    console.log('setUserPageConfig',res);
                    store.commit('user/UPDATE_PAGE_CONFIG',params);
                    this.$message.success(res.info||'设置成功');
                    this.$emit('close');
                    
                }).finally(()=>{
                    this.submitLoading = false;
                })
            },
            closeModal(){
                console.log('closeModal');
                // this.cbs.onClose({});
                this.$emit('close');
            },
            async getCommonConfig(){
                await API.getUserCommonConfig().then(res=>{
                    console.log('getCommonConfig',res);
                    this.allSettingConfig = res.data||[];
                    this.getUserPageConfig();
                })
            },
            getUserPageConfig(){
                this.dataLoading = true;
                API.getUserPageConfig().then(res=>{
                    console.log('getUserPageConfig',res);
                    let resData = res.data||{};
                    Object.keys(resData).forEach(key=>{
                        let actionData = this._findFieldByName(this.allSettingConfig,key);
                        let optionValueList = (actionData?actionData.options:[]).map(item=>item.value);
                        let checkedVal = resData[key];
                        this.$set(this.formItem,key,optionValueList.includes(checkedVal)?checkedVal:optionValueList[0]||'');
                    })
                }).finally(()=>{
                    this.dataLoading = false;
                })
            },
            dblClickRadio(item){
                // 单选 双击清空
                this.$set(this.formItem,item.name,'');
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .form-box{
        min-height: 200px;
        margin-bottom: 60px;

        .group-item{
            border: dashed 1px #ddd;
        }
    }
</style>
